// extracted by mini-css-extract-plugin
export var arrow = "_1x-4";
export var arrowButton = "_1x-6";
export var columnResizer = "_1x-a";
export var columnResizerActive = "_1x-b";
export var columnResizerIndicator = "_1x-c";
export var columnResizerIndicatorActive = "_1x-d";
export var headerCell = "_1x-0";
export var help = "_1x-3";
export var hoverArrow = "_1x-5";
export var icon = "_1x-2";
export var iconButton = "_1x-9";
export var iconWrapper = "_1x-8";
export var noBorder = "_1x-e";
export var sortableHeaderCell = "_1x-1";
export var textButton = "_1x-7";